var render = function render(){var _vm=this,_c=_vm._self._c;return _c('streaming-line-four-dataset-chart',{ref:"statsCountChart",attrs:{"height":300,"chart-data":_vm.charData,"dataset1":_vm.fiveSecsdataset,"dataset2":_vm.tenSecsdataset,"dataset3":_vm.thirtySecsdataset,"dataset4":_vm.sixtySecsdataset,"is-started":_vm.isStarted,"options":_vm.chartOption,"time-scale":_vm.scala}})
}
var staticRenderFns = []

export { render, staticRenderFns }